/** @format */

import styled from 'styled-components';

export const Wrapper = styled.div<{ $border: boolean }>`
  overscroll-behavior-x: none;
  border-bottom: ${({ theme, $border }) => $border && `1px solid ${theme.colors.alternativeGreyLight};`};
`;

export const Container = styled.nav<{ $page: 'home' | 'page' | 'search' | 'blog' | 'listing' }>`
  @media screen and (min-width: 1160px) {
    --content-inline-padding: ${({ $page }) => {
      if ($page === 'search') return 2.5;
      return 5;
    }}rem;
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
    --content-inline-padding: 0;
  }

  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  max-width: 1440px;
  margin-inline: auto;
  width: 100%;
  padding-inline: var(--content-inline-padding);
`;

export const ExternalNavItems = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
    justify-content: flex-start;
  }
`;

export const ExternalNavItem = styled.div<{}>`
  height: 100%;
  width: 100%;
  &:not(:has(a)) {
    padding: 0.5rem;
  }
  &:nth-child(1),
  &:nth-child(5),
  &:nth-child(6) {
    border-right: ${({ theme }) => `1px solid ${theme.colors.alternativeGreyLight}`};
  }
  color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.125rem;
`;

export const ExternalNavItemLink = styled.a<{ $active: boolean }>`
  --link-color: ${({ theme, $active }) => ($active ? theme.colors.joivy['white'] : theme.colors.joivy['teal-dark'])};
  --link-color-hover: ${({ theme }) => theme.colors.joivy['white']};
  --link-bg-color: ${({ theme, $active }) => ($active ? theme.colors.joivy['teal-light'] : 'transparent')};
  --link-bg-color-hover: ${({ theme }) => theme.colors.joivy['teal-dark']};

  display: flex;
  align-items: center;
  position: relative;
  gap: 0.5rem;
  height: 100%;
  width: 100%;
  padding: 0.5rem;
  text-decoration: none;
  color: var(--link-color);
  background-color: var(--link-bg-color);
  transition: all 0.3s ease-in-out;
  img {
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    background-color: var(--link-bg-color-hover);
    color: var(--link-color-hover);
    img {
      filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(293deg) brightness(105%) contrast(104%);
    }
  }
`;
